import { useEffect, useState } from "react";

import { Outlet, useLocation } from "react-router-dom";

import Sidebar from "../components/layout/sidebar/Sidebar";

import Header from "../components/layout/header/Header";

import "./DashboardLayout.css";
import Footer from "../components/layout/footer/Footer";

export default function DashboardLayout() {
  const location = useLocation();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  /**
   * CLOSE MOBILE SIDEBAR
   * ON ROUTE CHANGE
   */
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="dashboard-layout">
      {/* MOBILE OVERLAY */}
      <div
        className={`dashboard-layout__overlay ${
          sidebarOpen ? "dashboard-layout__overlay--active" : ""
        }`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* SIDEBAR */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* MAIN */}
      <div className="dashboard-layout__main">
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main className="dashboard-layout__content">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
